import { create } from 'zustand';
import { SelectedVehicle } from '../components/VehicleSelectionForm.js';

export type ProductType = "clearance" | "";

export type ModalState = {
  isModalOpen: boolean;
  fitmentSku?: string
  ptype: ProductType
  onSelectCallback: ((vehicle: SelectedVehicle) => void) | null;
  openModal: (callback: (vehicle: SelectedVehicle) => void, fitmentSku?: string, ptype?: ProductType) => void;
  closeModal: () => void;
};

export const useVehicleModalStore = create<ModalState>((set) => ({
  isModalOpen: false,
  onSelectCallback: null,
  ptype: "",
  openModal: (callback, sku, ptype) => set({ isModalOpen: true, onSelectCallback: callback, fitmentSku: sku, ptype: ptype || "" }),
  closeModal: () => set({ isModalOpen: false, onSelectCallback: null, fitmentSku: undefined }),
}));